import { Link } from "react-router-dom";
import { X, Globe, ChevronRight, ChevronDown } from "lucide-react"; // npm i lucide-react
import './Navbar.css'

export default function MobileNavbar({
    isMobileMenuOpen,
    setIsMobileMenuOpen,
    servicesDropdownOpen,
    setServicesDropdownOpen,
    sankalpPujaServicesDropdownOpen,
    setSankalpPujaServicesDropdownOpen,
    darshanServicesDropdownOpen,
    setDarshanServicesDropdownOpen,
    templeServicesDropdownOpen,
    setTempleServicesDropdownOpen,
    astrologyServicesDropdownOpen,
    setAstrologyServicesDropdownOpen,
    panditServicesDropdownOpen,
    setPanditServicesDropdownOpen,
    chadhavaServicesDropdownOpen,
    setChadhavaServicesDropdownOpen,
    isAuthenticated,
    setConfirmationModal,
    setShowLoginPopUp,
    isActive,
    t,
}) {
    if (!isMobileMenuOpen) return null;



    const ToggleIcon = ({ open }) =>
        open ? <ChevronDown color="#fff" size={18} /> : <ChevronRight color="#fff" size={18} />;

    return (
        <div
            className="position-fixed top-0 start-0 w-100 h-100"
            data-aos="fade-down"
            data-aos-duration="2000"

            style={{ backgroundColor: "#111", zIndex: 9999, overflowY: "auto" }}
        >
            {/* Top bar */}
            <div className="d-flex justify-content-between align-items-center p-3 border-bottom border-secondary">
                <X
                    color="#fff"
                    size={28}
                    style={{ cursor: "pointer" }}
                    onClick={() => setIsMobileMenuOpen(false)}
                />

            </div>

            {/* Menu List */}
            <ul className="list-unstyled m-0">
                {[
                    {
                        label: t("Pujas"),
                        open: servicesDropdownOpen,
                        toggle: () => setServicesDropdownOpen(!servicesDropdownOpen),
                        links: [
                            { path: "/remedy-puja", label: "Remedy Puja" },
                            { path: "/homam-puja", label: "Homam" },
                        ],
                    },
                    {
                        label: t("Sankalp Puja"),
                        open: sankalpPujaServicesDropdownOpen,
                        toggle: () =>
                            setSankalpPujaServicesDropdownOpen(!sankalpPujaServicesDropdownOpen),
                        links: [
                            { path: "/remedy-subscription-puja", label: "Subscription Remedy Pujas" },
                            { path: "/homam-subscription-puja", label: "Subscription Homam Pujas" },
                        ],
                    },


                    // {
                    //     label: "Astrology",
                    //     open: astrologyServicesDropdownOpen,
                    //     toggle: () =>
                    //         setAstrologyServicesDropdownOpen(!astrologyServicesDropdownOpen),
                    //     links: [
                    //         // { path: "/services/horoscope", label: "Horoscope" },
                    //         { path: "/basic-details", label: "Basic Astrology" },
                    //         { path: "/numerology", label: "Numerology" },
                    //         { path: "/Prediction", label: "Zodiac" },
                    //         { path: "/daily-panchang", label: "Panchang" },

                    //     ],
                    // },
                    {
                        label: t("Pandit"),
                        open: panditServicesDropdownOpen,
                        toggle: () => setPanditServicesDropdownOpen(!panditServicesDropdownOpen),
                        links: [
                            { path: "/daily-pandit-puja", label: "Daily Pandit (Puja)" },
                            { path: "/pandit-puja", label: "Pandit Booking" },
                        ],
                    },
                    // {
                    //     label: "Chadhava",
                    //     open: chadhavaServicesDropdownOpen,
                    //     toggle: () =>
                    //         setChadhavaServicesDropdownOpen(!chadhavaServicesDropdownOpen),
                    //     links: [
                    //         { path: "#", label: "Go Seva" },
                    //         { path: "#", label: "Brahmin Bhog" },
                    //         { path: "#", label: "Temple Chadhava" },
                    //     ],
                    // },
                ].map((menu, idx) => (
                    <li key={idx} /* removed border-bottom */>
                        <div
                            className="d-flex justify-content-between align-items-center px-3 py-2" // ↓ smaller vertical padding
                            style={{ color: "#fff", fontWeight: "600", cursor: "pointer" }}
                            onClick={menu.toggle}
                        >
                            <span>{menu.label}</span>
                            <ToggleIcon open={menu.open} />
                        </div>

                        {menu.open && (
                            <ul className="list-unstyled ps-4 mb-2"> {/* mb-2 reduces gap below */}
                                {menu.links.map((subItem, i) => (
                                    <li key={i} className="mb-1"> {/* mb-1 tighter spacing */}
                                        <Link
                                            to={subItem.path}
                                            className="d-block text-decoration-none"
                                            onClick={() => setIsMobileMenuOpen(false)}
                                            style={{
                                                color: isActive(subItem.path) ? "#d09d18" : "#ddd",
                                                fontSize: "0.95rem",
                                            }}
                                        >
                                            {t(subItem.label)}
                                        </Link>
                                    </li>
                                ))}

                            </ul>
                        )}


                    </li>
                ))}

                {/* --- 🔽 Simple single-click links at the bottom --- */}
                <li className="px-3 py-2" style={{ color: "#fff", fontWeight: "500", cursor: "pointer" }}>
                    <Link
                        to="/temples"
                        className="d-block text-decoration-none"
                        onClick={() => setIsMobileMenuOpen(false)}
                        style={{
                            color: isActive("/temple") ? "#d09d18" : "#ddd",

                        }}
                    >
                        {t("Temples")}
                    </Link>
                </li>

                <li className="px-3 py-2" style={{ color: "#fff", fontWeight: "500", cursor: "pointer" }}>
                    <Link
                        to="/services/e-store"
                        className="d-block text-decoration-none"
                        onClick={() => setIsMobileMenuOpen(false)}
                        style={{
                            color: isActive("/services/e-store") ? "#d09d18" : "#ddd",

                        }}
                    >
                        {t("E-Store")}
                    </Link>
                </li>
                <li className="px-3 py-2" style={{ color: "#fff", fontWeight: "500", cursor: "pointer" }}>
                    <Link
                        to="/services/horoscope"
                        className="d-block text-decoration-none"
                        onClick={() => setIsMobileMenuOpen(false)}
                        style={{
                            color: isActive("/services/horoscope") ? "#d09d18" : "#ddd",

                        }}
                    >
                        {t("Astrology")}
                    </Link>
                </li>

                {/* Login / Logout */}
                <li className="mt-3 px-3"> {/* removed border-top */}
                    {isAuthenticated ? (
                        <span
                            className="d-block text-danger fw-semibold"
                            style={{ cursor: "pointer" }}
                            onClick={() => setConfirmationModal(true)}
                        >
                            {t("Logout")}
                        </span>
                    ) : (
                        <span
                            className="d-block text-danger fw-semibold"
                            style={{ cursor: "pointer" }}
                            onClick={() => setShowLoginPopUp(true)}
                        >
                            {t("Login")}
                        </span>
                    )}
                </li>
            </ul>

        </div>
    );
}
